/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IRegionSelectorData } from './region-selector.data';
import { IRegionSelectorProps } from './region-selector.props.autogenerated';

export interface IRegionSelectorViewProps extends IRegionSelectorProps<IRegionSelectorData> {}

/**
 *
 * RegionSelector component
 * @extends {React.PureComponent<IRegionSelectorProps<IRegionSelectorData>>}
 */
class RegionSelector extends React.PureComponent<IRegionSelectorProps<IRegionSelectorData>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default RegionSelector;
